<template>
  <ConversationTbColumns />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
